<template>
  <div class="nc-iframe-container" :style="styleVars">
    <iframe
      :src="embedSrc"
      class="nc-iframe"
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border-radius: var(--rounded)"
      allowfullscreen
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
    >
    </iframe>
  </div>
</template>

<script lang="ts">
export default defineNuxtComponent({
  name: 'LibraryIframe',

  props: {
    src: {
      required: true,
      type: String,
    },

    hRatio: {
      required: false,
      type: Number,
      default: 2,
    },
    wRatio: {
      required: false,
      type: Number,
      default: 3,
    },
  },

  computed: {
    embedSrc(): string | null {
      if (this.resource === 'youtube') {
        function getYouTubeVideoId(url: string) {
          // Regular expression to match the video ID in various YouTube URL formats
          const regExp = /^.*(youtu.be\/|v\/|\/u\/\w\/|embed\/|watch\?v=|\&v=|watch\?vi=)([^#\&\?]*).*/;
          const match = url.match(regExp);
          if (match && match[2].length === 11) {
            return match[2];
          } else {
            return null;
          }
        }

        const id = getYouTubeVideoId(this.src);
        return `https://www.youtube.com/embed/${id}`;
      }
      return this.src;
    },

    resource(): 'youtube' | null {
      if (this.src) {
        if (this.src.includes('youtu.be') || this.src.includes('youtube')) {
          return 'youtube';
        }
      }
      return null;
    },

    imageRatio() {
      return (this.hRatio / this.wRatio) * 100;
    },

    styleVars() {
      return {
        '--nc-iframe-ratio': `${this.imageRatio}%`,
        '--nc-mobile-image-ratio': `${this.imageRatio}%`,
      };
    },
  },
});
</script>

<style scoped>
.nc-iframe-container {
  position: relative;
  width: 100%; /* This makes the container responsive */
  padding-bottom: var(--nc-iframe-ratio); /* This maintains aspect ratio */
}

@media (max-width: 1023px) {
  .nc-iframe-container {
    padding-bottom: var(--nc-mobile-image-ratio); /* This maintains aspect ratio on mobile */
  }
}

.nc-iframe-container .nc-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* This ensures the image covers the container */
}
</style>
